import React from "react";
import UserIcon from "../../../../../gd-components/icons/user/user";
import Classes from "classnames";

type Props = {
    className?  : string
    field       : any
    disabled?   : boolean
    option      : Option

    onClick     : callback

    children?   : any
}

export default function FieldUser_FormValueNotEmpty(props: Props) {

    const classes = Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className)

    let icon
    if (props.option.icon) {
        // case for {actionRequired userId}
        icon = <div className={Classes("ui5-ico-14 m-r-8", props.option.icon)} />
    } else {
        icon = <UserIcon className="m-r-8" userId={props.option.value} size="22"/>
    }

    const valueClasses = Classes("txt-truncate", {
        "ui5-txt-default"           : !props.disabled,
        "ui5-txt-no-accent-default" : props.disabled
    })

    return (
        <React.Fragment>
            <div className  = {classes}
                 onClick    = {props.onClick}>

                {icon}

                <div className={valueClasses}>
                    {props.option.label}
                </div>

            </div>

            {props.children}

        </React.Fragment>
    );
}
